export default "__VITE_ASSET__C0upma1N__"